import styled from "styled-components"

export const Iframe = styled.iframe`
    width: 100%;
    height: 100%;
`
